import type { SVGProps } from "react";
const SvgAirplane01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.867 3.78c.926-.748 1.964-.794 3.097-.778.587.009.88.013 1.115.104.373.145.67.442.815.815.091.235.095.528.104 1.115.016 1.133-.03 2.17-.778 3.097-.63.78-1.714 1.188-2.235 2.05-.398.656-.213 1.337-.042 2.038l1.28 5.245c.255 1.046.06 1.715-.67 2.446-.389.39-.713.37-1.028-.133l-3.862-6.154-1.845 1.466c-.669.532-1.003.798-1.179 1.172-.411.876-.15 2.192-.137 3.142.008.525-.446 1.56-1.088 1.594-.396.022-.531-.452-.66-.743l-1.232-2.802c-.294-.67-.306-.682-.976-.976l-2.802-1.233c-.29-.128-.765-.263-.743-.659.035-.642 1.07-1.096 1.594-1.088.95.013 2.266.274 3.142-.137.374-.176.64-.51 1.172-1.18l1.466-1.844-6.154-3.862c-.503-.316-.522-.639-.133-1.028.73-.73 1.4-.925 2.446-.67l5.245 1.28c.7.171 1.382.356 2.039-.042.861-.52 1.269-1.604 2.049-2.235"
    />
  </svg>
);
export default SvgAirplane01;
